import React from "react";
import ButtonOrang from "./ButtonOrang";

const BarrerasTecnologicas = ({ onButtonClick }) => (
  <section className="w-full bg-sidom-blue  px-2 flex flex-col items-center justify-center">
    <div className="container mt-[70px] md:mt-[100px] lg:mt-[90px] mb-[70px] md:mb-[100px] lg:mb-[90px]  text-left">
      <h1 className="text-3xl leading-[1.3]  md:text-4xl font-normal mb-6 text-sidom-orange">
        <span className="font-extrabold leading-[1.3] ">Eliminá </span>barreras
        tecnológicas.
        <span className="font-extrabold leading-[1.3] "> Ganá </span>eficiencia
        operativa. <span className="font-extrabold leading-[1.3] ">Reducí</span>{" "}
        costos de infraestructura.
      </h1>
      <p className="text-xs sm:text-sm md:text-base lg:text-xl mb-10 text-sidom-light">
        Plataforma creada para atender la realidad del avance tecnológico y
        rapidez necesaria en la operativa diaria de los estudios aduaneros,
        buscando brindar la mayor eficiencia en los procesos internos,
        reduciendo errores y aumentando la calidad del servicio que prestan.
      </p>
      <ButtonOrang
        onClick={onButtonClick}
        text="¡Quiero probar MiSIM!"
        background="bg-sidom-orange"
        textColor="text-sidom-light"
        bloke={true}
      />
    </div>
  </section>
);

export default BarrerasTecnologicas;
